import './creditsPage.scss';

// import { globalHistory, useLocation, useNavigate } from '@reach/router';
import { useLocation, useNavigate } from '@reach/router';
import { Divider, Typography } from 'antd';
import { useState } from 'react';
import { useRecoilState } from 'recoil';

import { freeCreditModal } from '../../../recoil/atoms/freeCreditModal';
import { userData as userRecoil } from '../../../recoil/atoms/userDataAtom';
// import FreeCreditsModal from '../../components/freeCreditsModal/FreeCreditsModal';
import { Page } from '../../components/layout/Page';
import { CreditsCard } from '../../components/shared/CreditsCard/CreditsCard';
import { useGetUserDetails } from '../../services/myProfile/useGetUserDetails';
import { useGetAllPackages } from '../../services/packages/useGetAllPackages';

const { Title } = Typography;
export const CreditsPage = () => {
  const curLocation = useLocation();
  const navigate = useNavigate();
  const { data } = useGetAllPackages();
  const [user] = useRecoilState(userRecoil);
  //@ts-ignore
  const userId = user?.data?.id;
  const { data: userDetails } = useGetUserDetails(userId);
  const [modalFreeCredits, setModalFreeCredits] = useState<boolean>(false);
  const [redirectLocation, setRedirectLocation] = useState<string>('');
  const [showFreeCredits, setShowFreeCredits] = useRecoilState(freeCreditModal);

  // useEffect(() => {
  //   setShowFreeCredits(true);
  //   console.log('1111111111111111111');
  // }, []);

  // console.log('showFreeCredits ==> ', showFreeCredits);

  // useEffect(() => {
  //   console.log('in EFFECT showFreeCredits ==> ', showFreeCredits);
  //   if (
  //     showFreeCredits &&
  //     (!userDetails?.completed_free_credit_tabs.about_me ||
  //       !userDetails?.completed_free_credit_tabs.gallery ||
  //       !userDetails?.completed_free_credit_tabs.preferences)
  //   ) {
  //     return globalHistory.listen(({ action, location }) => {
  //       if (
  //         (action === 'PUSH' && !location.pathname.includes(`${curLocation.pathname}`)) ||
  //         action === 'POP'
  //       ) {
  //         setRedirectLocation(location.pathname);
  //         if (
  //           !userDetails?.completed_free_credit_tabs.about_me ||
  //           !userDetails?.completed_free_credit_tabs.gallery ||
  //           !userDetails?.completed_free_credit_tabs.preferences
  //         ) {
  //           navigate(`${curLocation.pathname}`);
  //           setModalFreeCredits(true);
  //         }
  //       }
  //     });
  //   } else {
  //     if (!redirectLocation) return;
  //     navigate(`${redirectLocation}`);
  //   }
  // }, [userDetails, curLocation.pathname, showFreeCredits]);

  const renderPackages = (isSpecial: PhpBool) => {
    return data
      ?.filter((item) => item.is_special_offer === isSpecial)
      .map((pkg) => (
        <CreditsCard
          redirectUrl={curLocation.href}
          packageDef={pkg}
          key={pkg.id}
          trigger={'credits_page'}
        />
      ));
  };

  return (
    <Page>
      <Title className={'page-header'} level={2}>
        Purchase credits to send messages
      </Title>

      <div
        className={'balance'}
        style={{
          // @ts-ignore
          backgroundColor: user?.data?.credits > 10 ? '#EDEDED' : '#F5DDDD',
        }}
      >
        <div
          className={'amount'}
          style={{
            // @ts-ignore
            color: user?.data?.credits > 10 ? '#010101' : '#D41411',
          }}
        >
          {
            // @ts-ignore
            user?.data?.credits
          }
        </div>
        <div className={'note'}>credits balance</div>
      </div>
      {
        // @ts-ignore
        user?.data?.credits <= 10 ? <div className={'top-up'}>Top up your credits</div> : null
      }
      <Divider dashed style={{ margin: 20 }} />
      <div className={'credits-page'}>{renderPackages(1)}</div>
      <Divider dashed style={{ margin: 20 }} />
      <div className={'credits-page'}>{renderPackages(0)}</div>

      {/* <FreeCreditsModal
        setOpenModalState={setShowFreeCredits}
        redirectLocation={redirectLocation}
        openModalState={modalFreeCredits}
        page="credits"
      /> */}
    </Page>
  );
};
